import { createSelector } from 'reselect'
// import { List } from 'immutable'

const subcontractCostSelector = state => state.get('subcontractCost')

export const getIsFetching = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return subcontractCost.subcontractCostGet.isFetching
    || subcontractCost.subcontractCostCreate.isFetching
    || subcontractCost.subcontractCostEdit.isFetching
    || subcontractCost.subcontractCostExport.isFetching
  }
)
export const getSubcontractCostData = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return subcontractCost.subcontractCostGet
  }
)
export const createSubcontractCostData = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return subcontractCost.subcontractCostCreate
  }
)
export const editSubcontractCostData = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return subcontractCost.subcontractCostEdit
  }
)
export const exportSubcontractCostData = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return subcontractCost.subcontractCostExport.url
  }
)
export const redirectSubcontractCost = createSelector(
  subcontractCostSelector,
  subcontractCostImmutable => {
    const subcontractCost = subcontractCostImmutable.toJS()
    return ({
      redirect: (subcontractCost.subcontractCostGet.redirect
      || subcontractCost.subcontractCostCreate.redirect
      || subcontractCost.subcontractCostEdit.redirect
      || subcontractCost.subcontractCostExport.redirect),
      isAuthenticated: (subcontractCost.subcontractCostGet.isAuthenticated
      || subcontractCost.subcontractCostCreate.isAuthenticated
      || subcontractCost.subcontractCostEdit.isAuthenticated
      || subcontractCost.subcontractCostExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/subcontract-cost/subcontract-cost-selector.js